// import React from "react";
// import PrivacyPolicy from "./pages/retailerpolicy";

// const App = () => {
//   return (
//     <div>
//       <PrivacyPolicy />
//     </div>
//   );
// };

// export default App;

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RetailerAppPolicy from "./pages/retailerpolicy";
import CustomerAppPolicy from "./pages/customerpolicy";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RetailerAppPolicy />} />
        <Route
          path="/customer-privacy-policy"
          element={<CustomerAppPolicy />}
        />
      </Routes>
    </Router>
  );
}

export default App;
